const paramTypes = {
    ROUTE_PARAM: 0,
    QUERY_PARAM: 1
};

export default paramTypes;